import React from 'react';
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import theme from '../../theme';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          border: `1px solid ${theme.palette.grey.w200}`,
          padding: '5px'
        }}
      >
        <p>{payload[0].payload.name} : {payload[0].payload.value}</p>
      </div>
    );
  }

  return null;
}

const PieChartSimple = ({ chartData, settings, colors }) => {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          cx="50%"
          cy="50%"
          outerRadius={80}
          labelLine={false}
          fill="#8884d8"
        // label
        >
          {chartData?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </ResponsiveContainer>
  )
}

export default PieChartSimple;